<template>
	<v-card class="mb-1">
		<v-card-title>
			{{joint.name_pt}}
			<v-spacer></v-spacer>
			<v-btn class="ml-3" icon @click="showEdit = true">
				<v-icon color="primary">mdi-pencil</v-icon>
			</v-btn>
			<v-btn class="ml-1" icon @click="showDeleteJoint = true">
				<v-icon color="primary">mdi-delete</v-icon>
				<DeleteConfirmationDialog v-model="showDeleteJoint" item="joint" @delete="deleteJoint" />
			</v-btn>
		</v-card-title>
		<v-card-subtitle>
			<v-chip class="mr-2" small :color="joint.color">{{joint.code}}</v-chip>
			<v-chip v-if="joint.bilateral" small>Bilateral</v-chip>
		</v-card-subtitle>
		<v-card-text>
			<JointTests :items="joint.tests" type="test" :jointId="joint.id" :manipulations="joint.manipulations" />
			<JointTests class="mt-2" :items="joint.manipulations" type="manipulation" :jointId="joint.id" />
		</v-card-text>
		<v-dialog v-model="showEdit" max-width="40%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="jointForm" v-model="validForm">
						<v-row no-gutters>
							<v-col cols="6">
								<v-text-field
									v-model="joint.name_pt"
									:label="$gettext('Name') + ' PT'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
              <v-col cols="6">
								<v-text-field
									v-model="joint.code"
									:label="$gettext('Code')"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="joint.name_en"
									:label="$gettext('Name') + ' EN'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
              <v-col cols="6">
								<v-checkbox
									v-model="joint.bilateral"
									class="mt-0 pt-0"
									color="primary"
									:label="$gettext('Bilateral')"
									hide-details
								/>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="joint.name_es"
									:label="$gettext('Name') + ' ES'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
              <v-col cols="6">
								<v-color-picker hide-inputs v-model="joint.color"></v-color-picker>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEdit = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editJoint">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import JointTests from "@/components/admin/JointTests.vue";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
	name: "Joint",
	props: ["joint"],
	components: {
		JointTests,
		DeleteConfirmationDialog
	},
	data: () => ({
		showEdit: false,
		validForm: false,
		showDeleteJoint: false
	}),
	computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
	},
	methods: {
		editJoint() {
			if (this.$refs.jointForm.validate()) {
				const form = new FormData();
				form.append("name_pt", this.joint.name_pt);
				form.append("name_en", this.joint.name_en);
				form.append("name_es", this.joint.name_es);
				form.append("color", this.joint.color);
				form.append("code", this.joint.code);
				form.append("bilateral", this.joint.bilateral);
				axios
					.post("/osteopathy/joint/" + this.joint.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.showEdit = false;
						}
					})
					.catch(error => console.log(error));
			}
		},
		deleteJoint() {
			axios
				.post("/osteopathy/joint/" + this.joint.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted")
						this.$emit("delete-joint", this.joint);
					else this.showError = true;
				})
				.catch(error => console.log(error));
		}
	}
};
</script>